/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';
import filter from 'lodash/filter';

import {
  LayerGroup, LeafletEvent, Marker, point, DivIcon,
  markerClusterGroup,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import EventIconMapperService from '@/services/EventIconMapperService';
import EventIconModalService from '@/services/EventIconModalService';
import { IModalData } from '@/services/layers/IModalData';
import AssetIconService from '@/services/AssetIconService';
import { toRaw } from 'vue';
import { IClusterIconSettings, IMarkerIconSettings } from '@/interfaces/IMapIconsSettings';
import MapIconsGeneratorService from '../MapIconsGeneratorService';

export default class EventsLayerService extends LayerService {
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const template = metaData.description;
    const {eventCategories} = store.state;
    const eventCateogory = eventCategories.find((category: any) => category.key === metaData.category.event_code);
    const iconCode = eventCateogory && eventCateogory.icon_code ? eventCateogory.icon_code : null;

    const modalData: IModalData = {
      title: metaData.name,
      content: template,
      navigationPoint: undefined,
      lastUpdate: metaData.update_time,
      createTime: metaData.create_time,
      icon: MapIconsGeneratorService.resolveIconUrl(iconCode, true),
      templateName: 'TemplateModalEvent',
      customClassName: 'modal--event',
      metaData: metaData,
      iconClassName: '',
    };

    store.commit('displayModal', modalData);
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.events;
    
    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const eventsSwichers = store.state.settings.mapEventLayers;
    const filteredCodes = Object.keys(eventsSwichers).filter(item => (eventsSwichers as any)[item]);

    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);

      if (filteredCodes.includes(feature.properties.category.event_code)) {
        markerClusterGroupInstance.addLayer(toRaw(singleMarker));
      }
    });

    return markerClusterGroupInstance;
  };

  generateClusterHtml(population: number) {
    const settings: IClusterIconSettings = {
      className: 'g__color--event',
      insideIcon:  require(`@/assets/img/icon-layers/single-icons/marker_e_hazards.svg`),
      population,
    };
    const iconHtml = MapIconsGeneratorService.getClusterIcon(settings);
    
    return iconHtml;
  }

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const {eventCategories} = store.state;
    const eventCateogory = eventCategories.find((category: any) => category.key === metaData.category.event_code);
    const iconCode = eventCateogory && eventCateogory.icon_code ? eventCateogory.icon_code : null;

    const settings: IMarkerIconSettings = {
      className: 'g__color--event',
      insideIcon: iconCode ?? '', // Provide a fallback value for undefined
      isBase64IconCode: true,
    };
    const iconHtml = MapIconsGeneratorService.getMarkerIcon(settings);

    return iconHtml;
  };

  // protected generateHtmlPointTemplate = (metaData: any): string => {
  //   // eslint-disable-next-line global-require
  //   const eventIcon = EventIconMapperService(this.layerType);

  //   // usunięte spacje w celu uniknięcia dodania znaków białych które niszczą
  //   // ikony dodane za pomocą icomoon
  //   const template: string = `
  //       <div
  //           class="map-simple-icon map-simple-icon--event"
  //           style='background-image: url("${require('@/assets/img/map-icons/' + eventIcon)}")'>
  //       </div>
  //     `;

  //   return template;
  // }
}